<script>
    export let text
</script>
<div>
    <h2>{text.main}</h2>
    <p>{text.sub}</p>
</div>
<style>
    div{
        display: flex;
    }
    h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 60px;
        line-height: 60px;
        text-align: left;
        color: #000;
        margin:0px;
    }
    p{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 60px;
        text-align: left;
        color: #000;
        margin:0px;
        margin-left: 20px;
    }
    @media screen and (max-width:640px){
        div{
            flex-direction: column;
        }
        h2{
            font-size: 40px;
            line-height: 40px;
        }
        p{
            font-size: 16px;
            line-height: 36px;
            margin: 0;
        }
    }
</style>